var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-startpos-lord"},[_c('div',[_vm._v("Faction: "+_vm._s(_vm.data.faction.name))]),_c('div',[_vm._v("Lord: "+_vm._s(_vm.data.lord.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }